import React from "react";

interface ErrorStateProps {
  title?: string;
  message: string;
}

export const ErrorState: React.FC<ErrorStateProps> = ({ title = "Failed to retrieve data", message }) => {
  return (
    <div className="flex-1 flex flex-col items-center justify-center p-8 text-center">
      <svg className="w-12 h-12 text-red-500 mb-3" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
      <h3 className="text-lg font-bold text-gray-900 mb-1">{title}</h3>
      <p className="text-sm text-gray-500 max-w-md">{message}</p>
    </div>
  );
};
